// extracted by mini-css-extract-plugin
export default {"overlay":"jw-z","bodyOpen":"kw-z","content":"lw-z","header":"mw-z","close":"nw-z","closeNoHeading":"ow-z"};